import { tns } from "tiny-slider/src/tiny-slider.module.js";
if (document.querySelector('#js-heroSlider')) {
    var slider = tns({
        autoplay: true,
        autoHeight: false,
        mode: "gallery",
        // autoplayButton: "#js-heroSlider__customize-toggle",
        autoplayTimeout: 4000,
        autoplayButtonOutput: false,
        container: '#js-heroSlider',
        controls: false,
        navContainer: "#js-heroSlider__nav",
        // controlsContainer: "#js-heroSlider__controls",
        items: 1,
        center: true,
        loop: true,
        rewind: false,
        mouseDrag: true,
        navAsThumbnails: false,
        navPosition: 'bottom',
        speed: 500,
        // animateDelay: 1000;
        swipeAngle: false,
        preventActionWhenRunning: false
        
        // "fixedWidth": '100%'
        // "animateIn": 'DOOOG'
    });
}

// var customizedFunction = function (info, eventName) {
  // direct access to info object
  // console.log( );
  // document.querySelector('#js-heroSlider-item' + info.displayIndex).classList.add("--active");
  // document.querySelector('.js-heroSlider-item' + info.displayIndex).classList.add("--active");
  // info.container.classList.add("--active");
// }

// bind function to event
// slider.events.on('indexChanged', customizedFunction);

// remove function binding
// slider.events.off('transitionEnd', customizedFunction);